import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function About() {
  const certifications = ['Microsoft MCSE', 'Microsoft MCSD', 'Microsoft MCT'];

  return (
    <section id="about" className="about-section section-padding">
      <Container>
        <div className="section-divider"></div>
        <h2 className="section-title">About Me</h2>
        <p className="section-subtitle">A career built on passion for technology &amp; delivering results</p>

        <Row className="g-4 align-items-center">
          <Col lg={7}>
            <p className="about-text">
              With over <strong>30 years of experience</strong> in software development, I've evolved alongside the technology landscape — from ASP to ASP.NET to MVC, and now to <strong>Angular and single-page applications</strong>. My database journey has taken me from SQL to ORMs to MongoDB.
            </p>
            <p className="about-text mt-3">
              In recent years, I've been deeply focused on <strong>ecommerce</strong>, building multiple sites from scratch for startups alongside enterprise work. I'm passionate about using technology to improve businesses, especially in the web and online commerce space.
            </p>
            <p className="about-text mt-3">
              Beyond development, I'm also a <strong>published author</strong> with 5 technical books and a <strong>technical trainer</strong>, teaching Angular and other frameworks to developers worldwide — from startups to Fortune 500 companies.
            </p>
            <p className="about-text mt-3">
              <strong>Education:</strong> BS in Computer Science
            </p>
          </Col>
          <Col lg={5}>
            <div className="about-highlight">
              <h4>Certifications</h4>
              <div>
                {certifications.map((cert, index) => (
                  <span key={index} className="cert-badge">{cert}</span>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;
